import React from 'react';
import { useCurrentUser } from 'javascripts/hooks';
import { get as lodashGet } from 'lodash';

import Comment from './Comment';
import VoiceNote from './VoiceNote';
import type { CommentType } from './Comment';

const CommentListItem = ({
  item,
  languages,
}: {
  item: CommentType;
  languages?: {
    [key: string]: string[];
  };
}) => {
  const currentUser = useCurrentUser();
  const contributorType = lodashGet(item, 'contributor.__typename', 'Unknown');
  const contributorNodeId = lodashGet(item, 'contributor.id', '0');
  const isCurrentUser =
    contributorType === 'ProjectContributingUser' &&
    contributorNodeId === currentUser.node_id;

  switch (item.__typename) {
    case 'Comment':
      return (
        <Comment
          key={item.id}
          isCurrentUser={isCurrentUser}
          comment={item}
          originalLanguage={languages[item.databaseId]}
        />
      );
    case 'VoiceNote':
      return (
        <VoiceNote
          key={item.id}
          isCurrentUser={isCurrentUser}
          voiceNote={item}
        />
      );
    default:
      return null;
  }
};

export default CommentListItem;
